@if (_loading$ | async) {
  <ac-loading-panel />
} @else {
  <mat-sidenav-container>
    <mat-sidenav-content>
      <ac-header (menuTrigger)="sidenav.toggle()" />
      <main>
        @if (_errorSig(); as error) {
          <div class="p-6">
            <ac-info-box error small>
              <span class="paragraph-m">{{ error | translate }}</span>
            </ac-info-box>
          </div>
        } @else if (_webIsReady$ | async) {
          <router-outlet />
        }
      </main>
      <ac-footer />
    </mat-sidenav-content>
    <mat-sidenav #sidenav mode="over" position="end">
      <section class="sidenav__links">
        <ac-icon class="pointer close-icon" name="close" size="big" (click)="sidenav.toggle()" />
        <ac-nav-links side />
      </section>
      <section class="sidenav__data">
        <ac-side-nav-info-data />
      </section>
      <section class="sidenav__lang">
        @if (_shouldRenderLangSelection) {
          <ac-lang-selection side />
        }
      </section>
    </mat-sidenav>
  </mat-sidenav-container>
}
<ac-floating-alerts-container />
